export enum LOCAL_STORAGE_KEYS {
  USER = "user",
  USER_STORES = "userStores",
  USER_STORE_ID = "userStoreId",
  USER_STORE_NAME = "userStoreName",
  ORDER_LIST_BUFFER = "orderListBuffer",
}

export interface UserStore {
  storeId: string;
  storeName: string;
  role: "planner" | "admin";
}

export const getUserFromLocalStorage = () =>
  localStorage.getItem(LOCAL_STORAGE_KEYS.USER) ?? "";

export const getUserStoreNameFromLocalStorage = () =>
  localStorage.getItem(LOCAL_STORAGE_KEYS.USER_STORE_NAME) ?? "";

export const getUserStoreIdFromLocalStorage = () =>
  localStorage.getItem(LOCAL_STORAGE_KEYS.USER_STORE_ID) ?? "";

export const clearUserSessionFromLocalStorage = () => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_STORE_ID);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_STORE_NAME);
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_STORES);
};

export const getUserStoresFromLocalStorage = () =>
  JSON.parse(localStorage.getItem("userStores") ?? "[]") as UserStore[];

export const setUserStoresToLocalStorage = (userStores: UserStore[]) => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_STORES);
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.USER_STORES,
    JSON.stringify(userStores)
  );
};

export const setUserStoreNameToLocalStorage = (storeName: string) => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_STORE_NAME);
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_STORE_NAME, storeName);
};

export const setUserStoreIdToLocalStorage = (storeId: string) => {
  localStorage.removeItem(LOCAL_STORAGE_KEYS.USER_STORE_ID);
  localStorage.setItem(LOCAL_STORAGE_KEYS.USER_STORE_ID, storeId);
};

const getOrderListBufferKey = (storeId = getUserStoreIdFromLocalStorage()) =>
  storeId ? `${LOCAL_STORAGE_KEYS.ORDER_LIST_BUFFER}:${storeId}` : LOCAL_STORAGE_KEYS.ORDER_LIST_BUFFER;

export const getOrderListBufferFromLocalStorage = (
  storeId = getUserStoreIdFromLocalStorage()
): number => {
  const stored = Number(localStorage.getItem(getOrderListBufferKey(storeId)));
  return Number.isFinite(stored) && stored >= 0 ? stored : 0;
};

export const setOrderListBufferToLocalStorage = (
  buffer: number,
  storeId = getUserStoreIdFromLocalStorage()
) => {
  localStorage.setItem(getOrderListBufferKey(storeId), String(buffer));
};

